import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBackward: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="backward, delete, remove, key"><path d="M15 9.75L12.75 12M12.75 12L10.5 14.25M12.75 12L10.5 9.75M12.75 12L15 14.25M6 4.75H21.25V19.25H6L1.5 12L6 4.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBackward;
